interface MediaItem {
  image: string;
  title: string;
  tag: string;
  duration: string;
  desc: string;
}

const MEDIA_ITEMS: MediaItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=Manga%20artist%20studio%20workspace%20with%20drawing%20tablet%20and%20sketchbooks%2C%20warm%20lighting%2C%20creative%20atmosphere%2C%20professional%20digital%20art%20setup%2C%20cozy%20vibe%2C%20clean%20simple%20background&width=800&height=450&seq=media-01&orientation=landscape',
    title: '编辑解说：2024年度韩漫排行大盘点',
    tag: '编辑专栏',
    duration: '12分钟',
    desc: '编辑部为你盘点今年最值得追的韩漫作品，从画风到剧情全面分析，扶稳入坑。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Colorful%20manga%20bookstore%20shelf%20display%20with%20various%20comic%20volumes%2C%20warm%20lighting%2C%20organized%20shelves%2C%20cozy%20reading%20atmosphere%2C%20clean%20simple%20background&width=800&height=450&seq=media-02&orientation=landscape',
    title: '漫迷指南：日漫新番怎么选不踩雷',
    tag: '新手指南',
    duration: '8分钟',
    desc: '每季度几十部新番不知道看什么？这份选番指南帮你精准定位，告别选择困难。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Digital%20tablet%20displaying%20colorful%20manhua%20art%2C%20modern%20reading%20setup%2C%20warm%20ambient%20lighting%2C%20cozy%20environment%2C%20clean%20simple%20background%2C%20professional%20product%20photography&width=800&height=450&seq=media-03&orientation=landscape',
    title: '深度解析：国漫的崛起之路与未来趋势',
    tag: '行业观察',
    duration: '15分钟',
    desc: '从一人之下到镇魂街，国漫如何一步步走向世界舞台？深度分析行业现状与前景。',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">编辑专栏</h2>
          <p className="text-foreground-500 text-sm mt-3">编辑部精心撰写的漫画推荐、解析与行业观察</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform backdrop-blur-sm">
                    <i className="ri-play-fill text-xl text-primary-500 w-6 h-6 flex items-center justify-center ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="text-xs px-2 py-0.5 rounded-md bg-foreground-900/70 text-background-50 font-medium backdrop-blur-sm">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <span className="text-xs px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 font-medium mb-2 inline-block">
                  {item.tag}
                </span>
                <h3 className="text-base font-semibold text-foreground-900 mt-2 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}